// ToastNotification.js // D-002
'use client';
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_toastify_1 = require("react-toastify");
require("react-toastify/dist/ReactToastify.css");
class ToastNotification extends React.Component {
    constructor() {
        super(...arguments);
        this.notifySuccess = (message) => {
            react_toastify_1.toast.success(message);
        };
        this.notifyError = (message) => {
            react_toastify_1.toast.error(message);
        };
        this.notifyWarning = (message) => {
            react_toastify_1.toast.warn(message);
        };
        this.notifyInfo = (message) => {
            react_toastify_1.toast.info(message);
        };
        this.notifyDefault = (message) => {
            react_toastify_1.toast(message);
        };
    }
    render() {
        return (React.createElement("div", null,
            React.createElement(react_toastify_1.ToastContainer, { position: "top-right", autoClose: 5000, hideProgressBar: false, closeOnClick: true, draggable: true, pauseOnHover: true })));
    }
}
exports.default = ToastNotification;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/tostify-alert/tostify-alert.tsx
// module id = 3397
// module chunks = 0